import config from "../config";

const headers = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
});

const opts = (method, body) => ({
  method,
  headers: headers(),
  credentials: "include",
  ...(body ? { body: JSON.stringify(body) } : {}),
});

async function request(path, method = "GET", body = null) {
  const res = await fetch(`${config.apiUrl}${path}`, opts(method, body));
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.message || `Request failed (${res.status})`);
  return data;
}

// donor
export const generatePartnerKey = (payload) =>
  request("/api/partnerships/generate", "POST", payload);

export const getDonorPartnerships = () =>
  request("/api/partnerships/donor");

export const updatePartnership = (id, payload) =>
  request(`/api/partnerships/${id}`, "PATCH", payload);

export const pausePartnership = (id, notes) =>
  request(`/api/partnerships/${id}/pause`, "POST", notes ? { notes } : undefined);

export const resumePartnership = (id, notes) =>
  request(`/api/partnerships/${id}/resume`, "POST", notes ? { notes } : undefined);

export const revokePartnership = (id, notes) =>
  request(`/api/partnerships/${id}/revoke`, "POST", notes ? { notes } : undefined);

export const restorePartnership = (id, notes) =>
  request(`/api/partnerships/${id}/restore`, "POST", notes ? { notes } : undefined);

// receiver
export const claimPartnerKey = (partnerKey) =>
  request("/api/partnerships/claim", "POST", { partner_key: partnerKey });

export const getReceiverPartnerships = () =>
  request("/api/partnerships/receiver");

export const getPartnershipPrefs = (id) =>
  request(`/api/partnerships/${id}/prefs`);

export const updatePartnershipPrefs = (id, prefs) =>
  request(`/api/partnerships/${id}/prefs`, "PUT", prefs);

export const togglePref = (partnershipId, prefId, updates) =>
  request(`/api/partnerships/${partnershipId}/prefs/${prefId}`, "PATCH", updates);

// donor limits
export const getDonorLimits = (id) =>
  request(`/api/partnerships/${id}/limits`);

export const updateDonorLimits = (id, limits) =>
  request(`/api/partnerships/${id}/limits`, "PUT", limits);

// admin
export const getOrgPartnerships = (orgId) =>
  request(`/api/partnerships/org/${orgId}`);
